import React from "react";

function CCTVReporting() {
    return (
        <div>
            <h2>Communication & Reporting</h2>
            <p>
                Clear communication and accurate reporting are essential for CCTV operators. This module covers how to document incidents, use communication systems, and relay information to colleagues and authorities effectively.
            </p>

            <h3>Verbal Communication</h3>
            <ul>
                <li>Speak clearly and professionally over radios or intercoms</li>
                <li>Use standard call signs and phonetic alphabet when needed</li>
                <li>Keep messages concise and relevant</li>
                <li>Confirm receipt of important instructions</li>
            </ul>

            <h3>Incident Reporting</h3>
            <ul>
                <li>Record the who, what, when, where, and how of each incident</li>
                <li>Be objective — avoid opinions or assumptions</li>
                <li>Include time stamps and camera references</li>
                <li>Attach or reference relevant footage</li>
                <li>Submit reports promptly and securely</li>
            </ul>

            <h3>Daily Logs & Shift Handover</h3>
            <ul>
                <li>Maintain a log of all notable activity during your shift</li>
                <li>Include equipment checks, incidents, and visitor access</li>
                <li>Provide a clear handover to the next operator</li>
                <li>Highlight unresolved issues or ongoing surveillance</li>
            </ul>

            <h3>Liaising with Others</h3>
            <ul>
                <li>Communicate effectively with on-site security teams</li>
                <li>Relay accurate information to emergency services</li>
                <li>Maintain professionalism when dealing with the public</li>
                <li>Follow escalation procedures for serious incidents</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> You observe a suspicious individual loitering near a restricted area. What information should you communicate, and how would you document the event?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Reporting Standards</a></li>
                <li><a href="https://www.hse.gov.uk/toolbox/managing/reporting.htm" target="_blank" rel="noreferrer">HSE – Incident Reporting</a></li>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
            </ul>
        </div>
    );
}

export default CCTVReporting;
